import { z } from 'src/lib';
import { OperacionNOTESFields, OperacionNOTESParametroFields } from './fields';
import { FilePutFields } from 'src/pages/sistema/api/file-fields';

export const schemaOperacionNOTESParametroInsert = z.object({
    [OperacionNOTESParametroFields.Titulo]: z.string().min(1, 'El título es requerido'),
    [OperacionNOTESParametroFields.Valor]: z.string().min(1, 'El valor es requerido'),
    [OperacionNOTESParametroFields.Orden]: z.number()
});

export const schemaOperacionNOTESInsert = z.object({
    [OperacionNOTESFields.CodPais]: z.number(),
    [OperacionNOTESFields.CodUnidadNegocio]: z.number(),
    [OperacionNOTESFields.CodSectorComercial]: z.number(),
    [OperacionNOTESFields.FechaSolicitud]: z.date(),
    [OperacionNOTESFields.FechaVencimiento]: z.date(),
    
    [OperacionNOTESFields.TipoNota]: z.string(),
    [OperacionNOTESFields.Cliente]: z.string(),
    [OperacionNOTESFields.CapitalASuscribir]: z.string(),
    [OperacionNOTESFields.Moneda]: z.string(),
    [OperacionNOTESFields.Vencimiento]: z.date(),
    [OperacionNOTESFields.FechaEmision]: z.date(),
    [OperacionNOTESFields.Emisor]: z.string(),
    [OperacionNOTESFields.Subyacentes]: z.string(),
    [OperacionNOTESFields.ObsSubyacentes]: z.string(),
    [OperacionNOTESFields.Cupon]: z.string(),
    [OperacionNOTESFields.FrecuenciaPago]: z.string(),
    [OperacionNOTESFields.CondicionPago]: z.string(),
    [OperacionNOTESFields.ObsCupon]: z.string(),
    [OperacionNOTESFields.Participacion]: z.string(),
    [OperacionNOTESFields.FormaParticipacion]: z.string(),
    [OperacionNOTESFields.DescripcionParticipacion]: z.string(),
    [OperacionNOTESFields.ObsParticipacion]: z.string(),
    [OperacionNOTESFields.TipoProteccion]: z.string(),
    [OperacionNOTESFields.NivelProteccion]: z.string(),
    [OperacionNOTESFields.DescripcionProteccion]: z.string(),
    [OperacionNOTESFields.ObsProteccion]: z.string(),
    [OperacionNOTESFields.BarreraRescateAnticipado]: z.string(),
    [OperacionNOTESFields.CondicionRescateAnticipado]: z.string(),
    [OperacionNOTESFields.FrecuenciaObservacion]: z.string(),
    [OperacionNOTESFields.ObsRescateAnticipado]: z.string(),
    [OperacionNOTESFields.ArchivoGrafico]: z.string().nullable().optional(),
    [FilePutFields.File]: z.instanceof(File).optional().nullable(),
    
    [OperacionNOTESFields.Parametros]: z.array(schemaOperacionNOTESParametroInsert)
});

export const schemaOperacionNOTESParametroView = z.object({
    id: z.number(),
    [OperacionNOTESParametroFields.Titulo]: z.string(),
    [OperacionNOTESParametroFields.Valor]: z.string(),
    [OperacionNOTESParametroFields.Orden]: z.number().nullable()
});

export type OperacionNOTESInsert = z.infer<typeof schemaOperacionNOTESInsert>;
export type OperacionNOTESParametroInsert = z.infer<typeof schemaOperacionNOTESParametroInsert>;
export type OperacionNOTESParametroView = z.infer<typeof schemaOperacionNOTESParametroView>;